import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/project-profitability-index-calculator',
  component: () => import('../../routes/ProjectProfitabilityIndex.svelte'),
  card: {
    id: 'project-profitability-index',
    title: 'Project Profitability Index Calculator',
    description: 'Calculate the profitability index (PI) to rank mutually exclusive projects and determine if a project adds value.',
    icon: 'trending_up',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/project-profitability-index-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Project Profitability Index Calculator – Rank Projects by Investment Efficiency',
    description: 'Free Project Profitability Index (PI) calculator to rank capital investment projects. PI = PV of Future Cash Flows / Initial Investment. Determine if a project is worth pursuing.',
  },
};

export default meta;
